import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuthToken, clearAuthToken } from '@/utils/api-client';
import { sessionAuthService } from '@/services/session-auth-service';

export function useAuthToken() {
  const { isAuthenticated, isLoading, user, getIdTokenClaims } = useAuth0();

  useEffect(() => {
    // First, check if we have a session token
    const sessionToken = sessionAuthService.getSessionToken();
    if (sessionToken) {
      // Update the window object to ensure API client can access it
      (window as any).__PROSCI_SESSION_TOKEN__ = sessionToken;
      return;
    }

    // Only try to get token if we're authenticated and not loading
    if (isAuthenticated && !isLoading) {
      // Use ID token for authentication
      getIdTokenClaims()
        .then(claims => {
          if (claims?.__raw) {
            setAuthToken(claims.__raw);
          }
        })
        .catch(error => {
          console.error('Failed to get ID token:', error);
          clearAuthToken();
        });
    } else if (!isAuthenticated && !isLoading) {
      clearAuthToken();
    }
  }, [isAuthenticated, isLoading, getIdTokenClaims, user]);
}